<template>
  <!--ファイル選択する際のファイル名のtooltipテンプレートを表示する-->
  <div v-tooltip.bottom="fileNameValue" class="input-item">
    <label class="input-item__label" :class="`${fileNameValue ? 'selected' : ''}`" :style="labelStyle">
      <span v-if="fileNameValue">
        {{ fileNameValue }}
      </span>
      <span v-else>
        {{ label }}
      </span>
      <input type="file" :value="inputValue" @change="(e) => importFile(e)" />
    </label>
  </div>
</template>

<script lang="ts">
import { i18n } from '@/i18n';
import { computed, defineComponent, PropType, reactive, ref, SetupContext, StyleValue, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';
interface IFileInput {
  fileName: string | undefined;
}

const t = i18n.t;

export default defineComponent({
  name: 'FileInput',
  components: {},
  props: {
    propFileName: {
      type: String,
      default: '',
    },
    label: {
      type: String as PropType<TranslateResult>,
      default: t('ファイルを選択してください'),
    },
    labelStyle: {
      type: Object as PropType<StyleValue | undefined>,
      default: undefined,
    },
  },
  setup(props, context: SetupContext) {
    const state = reactive<IFileInput>({
      fileName: props.propFileName,
    }) as Record<string, any>;
    const fileNameValue = computed(() => state.fileName);

    const inputValue = ref();
    const importFile = (e: Event) => {
      const value = (e.target as HTMLInputElement).value.replace(/C:\\fakepath\\/g, '');
      if (value) {
        state.fileName = value;
        context.emit('change', e);
      }
    };
    const resetInputFile = () => {
      inputValue.value = '';
      state.fileName = '';
    };
    watch(
      () => props.propFileName,
      () => {
        state.fileName = props.propFileName;
      }
    );
    return {
      importFile,
      resetInputFile,
      inputValue,
      fileNameValue,
    };
  },
});
</script>

<style lang="scss" scoped>
label > input {
  display: none;
}

label {
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  border-radius: 4px;
  padding: 0.4rem 0.5rem;
  border: solid 1px #ccc;
  background-color: #e9e9e9;
  color: #333;
  // border-color: #ccc;
  &:hover {
    background-color: #d7d7d7;
    transition: background-color 0.5s;
  }
}

label::after {
  content: '+';
  font-size: 1rem;
  color: #888;
  padding-left: 2px;
}
</style>
